import React, { useState, useEffect } from 'react';
import {
    Button, TextField, FormControl, Grid, MenuItem, Select, InputLabel, Autocomplete,
    Typography, Table, TableBody, TableCell, TableRow, TableHead, InputAdornment, Paper
} from '@mui/material';
import { useUser } from '../contexts/UserContext';
import imageCompression from 'browser-image-compression';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';
function GestionPromocionesTarjeta({ promotion, onCancel, onSave, isEditMode = false }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descuento, setDescuento] = useState({
        fechaInicio: '',
        fechaFin: '',
        descripcion: '',
        edadDesde: '',
        edadHasta: '',
        sexo: null,
        tarjetaBancaria: null,
        porcentaje: 0,
        porcentaje_remitido: 0,
        urlImagen: '',
    });
    const [imagePreview, setImagePreview] = useState(null);
    const [listaDescuentos, setListaDescuentos] = useState([]);
    const [tarjetasBancarias, setTarjetasBancarias] = useState([]);
    const [sexos, setSexos] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [descripcionImgPagWeb, setDescripcionImgPagWeb] = useState('');
    const [palabrasImgClavePagWeb, setPalabrasImgClavePagWeb] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    useEffect(() => {
        // Cargar perfiles y sexos al montar el componente
        // fetchPerfiles();
        fetchSexos();
        fetchTarjetasBancarias();
    }, []);

    // 

    useEffect(() => {
        if (promotion) {


            setDescuento({
                fechaInicio: promotion.fechaDesde ? promotion.fechaDesde.split('T')[0] : '',
                fechaFin: promotion.fechaHasta ? promotion.fechaHasta.split('T')[0] : '',
                descripcion: promotion.descripcion || '',
                edadDesde: promotion.edadDesde != null ? promotion.edadDesde : '',
                edadHasta: promotion.edadHasta != null ? promotion.edadHasta : '',
                sexo: promotion.idSexo || null,
                urlImagen: promotion.urlImagen || '',
                tarjetaBancaria: promotion.idTarjetaBancaria || null,
                porcentaje: 0,
                porcentaje_remitido: 0,
            });
            setDescripcionImgPagWeb(promotion.descripcionImgPagWeb || '');
            setPalabrasImgClavePagWeb(promotion.palabrasImgClavePagWeb || '');
            console.log('Promotion:', promotion);
            // Set image preview if urlImagen exists
            if (promotion.urlImagen) {
                if (typeof promotion.urlImagen === 'string') {
                    setImagePreview(promotion.urlImagen);
                } else if (promotion.urlImagen instanceof Blob || promotion.urlImagen instanceof File) {
                    setImagePreview(URL.createObjectURL(promotion.urlImagen));
                }
            }
            fetchTarjetasBancarias();
        }
    }, [promotion]);



    const fetchTarjetasBancarias = async () => {
        try {
            const response = await fetch(`${server}/MgTarjetasBancarias`);
            const data = await response.json();
            setTarjetasBancarias(data.$values);
        } catch (error) {
            console.error('Error al cargar las tarjetas de pago:', error);
        }
    };

    const fetchSexos = async () => {
        try {
            const response = await fetch(`${server}/MgSexoes`);
            const data = await response.json();
            setSexos(data.$values || []);
        } catch (error) {
            console.error('Error al cargar los sexos:', error);
        }
    };

    const comprimirImagen = async (imagen) => {
        const opciones = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1280,
            useWebWorker: true,
            initialQuality: 0.8
        };
        try {
            const imagenComprimida = await imageCompression(imagen, opciones);
            const extension = imagen.name.split('.').pop();
            const nuevoNombre = `${imagen.name.split('.')[0]}.${extension}`;
            return new File([imagenComprimida], nuevoNombre, { type: imagen.type, lastModified: Date.now() });
        } catch (error) {
            console.error('Error al comprimir imagen:', error);
            return imagen;
        }
    };

    const handleImageUpload = async (file) => {
        const archivoComprimido = await comprimirImagen(file);
        const username = '' + user.codigoUsuario + '';
        const formData = new FormData();
        formData.append('file', archivoComprimido);
        try {
            const promoIdParam = promotion ? `promoId=${promotion.id}` : 'promoId=0';
            const response = await fetch(`${server}/PrPromociones/upload?usuario=${username}&${promoIdParam}`, {
                method: 'POST',
                body: formData
            });
            if (response.ok) {
                const data = await response.json();
                setDescuento(prev => ({ ...prev, urlImagen: data.urlFoto }));
                if (data.urlFoto) {
                    setImagePreview(typeof data.urlFoto === 'string' ? data.urlFoto : URL.createObjectURL(data.urlFoto));
                }
            } else {
                alert('Error al subir la imagen');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error al subir la imagen');
        }
    };

    // useEffect para establecer los datos si promotion existe
    // useEffect(() => {
    //     if (promotion) {
    //         setDescuento({
    //             fechaInicio: promotion.fechaDesde ? promotion.fechaDesde.split('T')[0] : '',
    //             fechaFin: promotion.fechaHasta ? promotion.fechaHasta.split('T')[0] : '',
    //             descripcion: promotion.descripcion || '',
    //             edadDesde: promotion.edadDesde || '',
    //             edadHasta: promotion.edadHasta || '',
    //             sexo: promotion.idSexo || null,
    //             tarjetaBancaria: null,
    //             porcentaje: 0,
    //         });
    //         // Cargar los detalles de la promoción
    //         fetchPromotionDetails();
    //     }
    // }, [promotion]);


    useEffect(() => {
        // Si tenemos promoción *y* ya cargamos las tarjetas bancarias...
        if (promotion && tarjetasBancarias.length > 0) {
            fetchPromotionDetails();
        }
    }, [promotion, tarjetasBancarias]);

    const fetchPromotionDetails = async () => {
        try {
            // Obtener los detalles de la promoción
            const response = await fetch(`${server}/PrDetallesDeDescuentosXTarjetasBancarias/byIdPromocion/${promotion.id}`);
            const data = await response.json();
            const detalles = data.$values || [];

            console.log('detalles', detalles);
            // Mapear los detalles al formato de listaDescuentos
            const detallesFormateados = detalles.map(detalle => {
                const tarjetaEncontrada = tarjetasBancarias.find(t => t.id === detalle.idTarjeta);
                console.log('tarjetaEncontrada', tarjetaEncontrada);
                console.log('tarjetas bancarias', tarjetasBancarias);
                return {
                    id: detalle.id,
                    tarjetaBancaria: tarjetaEncontrada || null,
                    porcentaje: detalle.porcentaje,
                    porcentaje_remitido: detalle.descuentoRemitido,
                };
            });
            console.log('detallesFormateados', detallesFormateados);

            setListaDescuentos(detallesFormateados);
        } catch (error) {
            console.error('Error al cargar los detalles de la promoción:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'porcentaje' || name === 'porcentaje_remitido') {
            let porcentaje = parseFloat(value);

            if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
                alert('El porcentaje debe estar entre 0 y 100.');
                return;
            }

            setDescuento(prev => ({ ...prev, [name]: value }));
        } else {
            setDescuento(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAgregar = () => {


        if (!descuento.tarjetaBancaria) {
            return Swal.fire({ icon: 'error', title: 'Tarjeta no seleccionada', text: 'Elige una tarjeta bancaria.' });
        }
        if (listaDescuentos.some(i => i.tarjetaBancaria.id === descuento.tarjetaBancaria.id)) {
            return Swal.fire({ icon: 'info', title: 'Ya agregado', text: 'Esa tarjeta ya está en la lista.' });
        }
        const porcentaje = parseFloat(descuento.porcentaje);
        if (isNaN(porcentaje) || porcentaje < 0 || porcentaje > 100) {
            return Swal.fire({ icon: 'warning', title: 'Porcentaje inválido', text: 'Debe ser 0–100.' });
        }

        const nuevoDescuento = {
            id: 0,
            tarjetaBancaria: descuento.tarjetaBancaria,
            porcentaje: porcentaje,
            porcentaje_remitido: descuento.porcentaje_remitido,
        };

        setListaDescuentos(prev => [...prev, nuevoDescuento]);
        console.log('nuevoDescuento', nuevoDescuento);
        setDescuento(prev => ({ ...prev, tarjetaBancaria: null, porcentaje: 0, porcentaje_remitido: 0 }));
    };

    const handleEliminar = (index) => {
        setListaDescuentos(prev => {
            const itemToDelete = prev[index];
            // Si el detalle tiene id mayor a cero, agregarlo al arreglo de eliminados
            if (itemToDelete.id && itemToDelete.id > 0) {
                setDeletedItems(prevDeleted => [...prevDeleted, itemToDelete]);
            }
            // Remover el detalle de la lista de descuentos
            return prev.filter((_, i) => i !== index);
        });
    };

    const handleGuardarPromocion = async () => {
        try {
            // Validar campos requeridos
            if (!descuento.fechaInicio || !descuento.fechaFin || !descuento.descripcion) {
                return Swal.fire({ icon: 'error', title: 'Faltan datos', text: 'Completa fecha y descripción.' });
            }
            if (listaDescuentos.length === 0 && deletedItems.length === 0) {
                return Swal.fire({ icon: 'error', title: 'Sin cambios', text: 'Agrega o elimina al menos un descuento.' });
            }

            let codigoPromocion = promotion ? promotion.codigo : '';
            console.log('codigoPromocion', codigoPromocion);

            if (!promotion) {
                // Paso 1: Llamar a la API para obtener todas las promociones
                const responsePromociones = await fetch(`${server}/PrPromociones/promociones`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        search: '',
                        desde: descuento.fechaInicio,
                        hasta: descuento.fechaFin
                    })
                });

                const dataPromociones = await responsePromociones.json();
                const promocionesExistentes = dataPromociones.$values || [];

                // Paso 2: Filtrar promociones donde fechaInicio es igual a descuento.fechaInicio
                const promocionesMismaFechaInicio = promocionesExistentes.filter(promo => {
                    const fechaInicioPromo = promo.fechaDesde ? promo.fechaDesde.split('T')[0] : '';
                    return fechaInicioPromo === descuento.fechaInicio;
                });

                // Paso 3: Calcular el correlativo
                const correlativoNumero = promocionesMismaFechaInicio.length + 1;
                const correlativo = correlativoNumero.toString().padStart(3, '0');

                // Paso 4: Generar el código con formato [AÑO][MES][CORRELATIVO]
                const [yy, mm, dd] = descuento.fechaInicio.split('-').map(n => parseInt(n, 10));
                const fechaInicioDate = new Date(yy, mm - 1, dd);  // año, mesIndex, día
                console.log('fechaInicioDate', fechaInicioDate);
                // Mon Jun 01 2025 00:00:00 GMT-0600

                const año = yy.toString();
                const mes = mm.toString().padStart(2, '0');
                codigoPromocion = `${año}${mes}${correlativo}`;
                // const fechaInicioDate = new Date(descuento.fechaInicio);
                // const año = fechaInicioDate.getFullYear().toString();
                // const mes = (fechaInicioDate.getMonth() + 1).toString().padStart(2, '0');
                // codigoPromocion = `${año}${mes}${correlativo}`;
            }

            // Paso 5: Construir los datos para el encabezado, incluyendo el código
            const encabezadoData = {
                id: promotion ? promotion.id : undefined,
                codigo: codigoPromocion,
                fechaDesde: descuento.fechaInicio,
                fechaHasta: descuento.fechaFin,
                descripcion: descuento.descripcion,
                edadDesde: descuento.edadDesde !== '' ? parseInt(descuento.edadDesde) : null,
                edadHasta: descuento.edadHasta !== '' ? parseInt(descuento.edadHasta) : null,
                idSexo: descuento.sexo,
                urlImagen: descuento.urlImagen,
                idTipo: 3,
                ...(promotion
                    ? {
                        modificadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                        ingresadoPor: promotion.ingresadoPor,
                        fechaIngreso: promotion.fechaIngreso,
                    }
                    : { ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ' }
                ),
                descripcionImgPagWeb,
                palabrasImgClavePagWeb,
            };

            const method = promotion ? 'PUT' : 'POST';
            const url = promotion ? `${server}/PrPromociones/${promotion.id}` : `${server}/PrPromociones`;

            // Hacer la solicitud POST o PUT para guardar el encabezado
            const responseEncabezado = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(encabezadoData)
            });
            console.log('responseEncabezado', responseEncabezado);
            if (responseEncabezado.ok) {

                let promocionId;
                // console.log('responseEncabezado', responseEncabezado.json());
                if (!promotion) {
                    const promocionGuardada = await responseEncabezado.json();
                    promocionId = promocionGuardada.id ? promocionGuardada.id : promotion.id;
                } else {

                    promocionId = promotion.id;
                }
                const username = user?.codigoUsuario + '/';
                // Procesar detalles eliminados
                for (const item of deletedItems) {
                    try {
                        const response = await fetch(`${server}/PrDetallesDeDescuentosXTarjetasBancarias/${item.id}/${username}`, {
                            method: 'DELETE',
                        });
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.error('Error al eliminar detalle:', errorData);
                        }
                    } catch (error) {
                        console.error('Error al eliminar detalle:', error);
                    }
                }


                // Procesar detalles nuevos
                for (const item of listaDescuentos) {
                    if (!item.id || item.id === 0) {
                        // Detalle nuevo, realizar solicitud POST
                        const detalleData = {
                            idPromocion: promocionId,
                            idTarjeta: item.tarjetaBancaria.id,
                            porcentaje: item.porcentaje,
                            descuentoRemitido: item.porcentaje_remitido,
                            ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                        };
                        console.log(detalleData);
                        const responseDetalle = await fetch(`${server}/PrDetallesDeDescuentosXTarjetasBancarias`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(detalleData)
                        });

                        if (!responseDetalle.ok) {
                            const errorData = await responseDetalle.json();
                            return Swal.fire({ icon: 'error', title: 'Detalle falló', text: e.message });
                        }
                    }
                }

                Swal.fire({ icon: 'success', title: 'Guardado', text: 'Promoción guardada con éxito.' });
                
                // Llamar a onSave para cerrar el modal y refrescar datos
                if (onSave) {
                    onSave();
                }
                
                // Reiniciar el formulario solo si no estamos en modo edición
                if (!isEditMode) {
                    setDescuento({
                        fechaInicio: '',
                        fechaFin: '',
                        descripcion: '',
                        edadDesde: '',
                        edadHasta: '',
                        sexo: null,
                        tarjetaBancaria: null,
                        porcentaje: 0,
                        porcentaje_remitido: 0,
                        urlImagen: '',
                    });
                    setListaDescuentos([]);
                    setImagePreview(null);
                    setDescripcionImgPagWeb('');
                    setPalabrasImgClavePagWeb('');
                }

            } else {
                const errorData = await responseEncabezado.json();
                alert('Error al guardar la promoción: ' + errorData.message);
            }
        } catch (error) {
            console.error('Error al guardar la promoción y los descuentos:', error);
            alert('Hubo un error al guardar la promoción y los descuentos.');
        }
    };



    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    <br />
                    {/* <div className="row"> */}
                    {/* <div className="col-md-7 col-sm-12 offset-md-3"> */}
                    <Paper style={{ padding: 10, margin: "auto", maxWidth: '100%' }}>
                        <Typography variant="h6" gutterBottom>
                            Configuración de Promociones por Tarjeta Bancaria
                        </Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Fecha desde"
                                    type="date"
                                    name="fechaInicio"
                                    fullWidth
                                    value={descuento.fechaInicio}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Fecha hasta"
                                    type="date"
                                    name="fechaFin"
                                    fullWidth
                                    value={descuento.fechaFin}
                                    onChange={handleChange}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Descripción de la promoción"
                                    fullWidth
                                    name="descripcion"
                                    value={descuento.descripcion}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Edad desde (días)"
                                    type="number"
                                    name="edadDesde"
                                    fullWidth
                                    value={descuento.edadDesde}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    label="Edad hasta (días)"
                                    type="number"
                                    name="edadHasta"
                                    fullWidth
                                    value={descuento.edadHasta}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Sexo</InputLabel>
                                    <Select
                                        value={descuento.sexo}
                                        onChange={(event) => setDescuento(prev => ({ ...prev, sexo: event.target.value }))}
                                        required
                                    >
                                        {sexos.map((sexo) => (
                                            <MenuItem key={sexo.idSexo} value={sexo.idSexo}>{sexo.descripcionSexo}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <input
                                        type="file"
                                        id="urlImagen"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            if (e.target.files && e.target.files[0]) {
                                                handleImageUpload(e.target.files[0]);
                                            }
                                        }}
                                    />
                                    {(imagePreview || descuento.urlImagen) && (
                                        <div className="mt-2">
                                            <img
                                                src={imagePreview || descuento.urlImagen}
                                                alt="Preview"
                                                style={{ maxWidth: '200px', maxHeight: '200px' }}
                                            />
                                        </div>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Descripción Página Web" value={descripcionImgPagWeb} onChange={(e) => setDescripcionImgPagWeb(e.target.value)} fullWidth />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField label="Palabras clave" value={palabrasImgClavePagWeb} onChange={(e) => setPalabrasImgClavePagWeb(e.target.value)} fullWidth />
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete
                                    options={tarjetasBancarias}
                                    getOptionLabel={(option) => option.descripcion}
                                    onChange={(event, newValue) => setDescuento(prev => ({ ...prev, tarjetaBancaria: newValue }))}
                                    renderInput={(params) => <TextField {...params} label="Tarjeta Bancaria" />}
                                    value={descuento.tarjetaBancaria}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="Porcentaje"
                                    type="number"
                                    name="porcentaje"
                                    fullWidth
                                    value={descuento.porcentaje}
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                    }}
                                    inputProps={{
                                        min: 0,
                                        max: 100,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <TextField
                                    label="% Remitido"
                                    type="number"
                                    name="porcentaje_remitido"
                                    fullWidth
                                    value={descuento.porcentaje_remitido}
                                    onChange={handleChange}
                                    InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
                                    inputProps={{ min: 0, max: 100 }}
                                />
                                +   </Grid>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={handleAgregar}>
                                    Agregar
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Tarjeta</TableCell>
                                            <TableCell>Porcentaje</TableCell>
                                            <TableCell>Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {listaDescuentos.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{item.tarjetaBancaria?.descripcion || 'Tarjeta no disponible'}</TableCell>
                                                <TableCell>{item.porcentaje}%</TableCell>
                                                <TableCell>
                                                    <Button color="secondary" onClick={() => handleEliminar(index)} disabled={!tienePermiso('Eliminar Promoción Tarjeta')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 20 }}>
                                <Button variant="contained" color="secondary" onClick={onCancel}>
                                    Cancelar
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleGuardarPromocion} style={{ marginLeft: 10 }} disabled={!tienePermiso(isEditMode ? 'Editar Promoción Tarjeta' : 'Crear Promoción Tarjeta')}>
                                    Guardar Promoción
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                    {/* </div> */}
                    {/* </div> */}
                </div>
            </div>
        </>
    );
}

export default GestionPromocionesTarjeta;
